import script from "./SlugField.vue?vue&type=script&lang=js"
export * from "./SlugField.vue?vue&type=script&lang=js"

import exportComponent from "C:\\laragon\\www\\bipay-payg\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"SlugField.vue"]])

export default __exports__